<template>
  <div class="m-page">
    <!--<img src="../../../../public/images/personal/wzbg-00.png" style="position: absolute;top: 0;left: 0; z-index: -1">-->
    <m-header :iconWhite="true"></m-header>
    <div class="m-content">
      <img class="m-portrait" src="../../../public/images/personal/grzx-00.png" alt="">
      <div class="m-info">
        <button class="btn m-btn">问诊详情</button>
      </div>
      <div class="m-title">
        <h2>王大锤的问诊报告</h2>
        <p>2018-01-22</p>
      </div>
      <m-tab class="m-tab" :tabItems="tabItems" :width="30"></m-tab>
      <p class="m-hint text-center" id="report"><span>基于您填写的情况，得出的结论仅供参考</span></p>

      <ul class="m-list">
        <li class="m-item" v-for="(item,index) in symptomList" :key="index">
          <div class="m-name">
            <div>
              <img v-if="index === 0" src="../../../public/images/personal/wzbg-icon-01.png">
              <img v-if="index === 1" src="../../../public/images/personal/wzbg-icon-02.png">
              <img v-if="index === 2" src="../../../public/images/personal/wzbg-icon-03.png">
              <span>{{item.name}}</span>
            </div>
            <i class="icon icon-pen"></i>
          </div>
          <div class="m-nape">
            <span v-for="(r) in item.select" :key="r.id"><i v-if="index === 2" class="m-icon-1 icon icon-smile1"></i>{{r}}</span>
          </div>
        </li>
        <li class="m-item-end">
          <span>注：</span>
          <i class="icon icon-smile1"></i>
          <span>可改善的危险因素</span>
        </li>
      </ul>

      <p class="m-hint m-hint-btn" id="result"><span class="">周红，男，32岁，2018-06-12</span>
        <button>更换报告</button>
      </p>

      <ul class="m-list">
        <li class="m-item" v-for="(item,index) in symptomList1" :key="index">
          <div class="m-name">
            <div>
              <img v-if="index === 0" src="../../../public/images/personal/wzbg-icon-04.png">
              <img v-if="index === 1" src="../../../public/images/personal/wzbg-icon-05.png">
              <span>{{item.name}}</span>
            </div>
          </div>
          <div class="m-nape">
            <span v-for="(r) in item.select" :key="r.id">{{r}}<i v-if="index === 0" class="m-icon-2 icon icon-note"></i></span>
          </div>
        </li>
      </ul>

      <p class="m-hint m-hint-btn" id="risk"><span class="">根据问诊情况，建议您做以下专病筛查</span>
        <button>立即筛查</button>
      </p>

      <div class="m-disease-box">
        <div class="m-disease" v-for="(item,index) in 2" :key="index">
          <p class="m-tag">高危人群</p>
          <div class="m-layout">
            <div class="m-left">
              <img v-if="index === 0" src="../../../public/images/personal/wzbg-icon-061.png">
              <img v-if="index === 1" src="../../../public/images/personal/wzbg-icon-071.png">
            </div>
            <div class="m-right">
              <h4>慢阻肺</h4>
              <p>疾病风险评估</p>
            </div>
          </div>
        </div>
      </div>

      <div class="m-foot">
        <!--<div class="m-info">-->
        <!--<p class="m-info-left">单位已安排体检方案</p>-->
        <!--<p class="m-info-right">明细<i class="icon icon-arrow-bottom"></i></p>-->
        <!--</div>-->
        <div class="m-reset">情况有变化，重新问诊</div>
        <div class="m-next" @click="$router.push('/chooseHospital')">确认项目</div>
      </div>

    </div>
  </div>
</template>

<script>
import MHeader from '@/components/common/header/m-header'
import MTab from '@/components/common/tabs/m-tab'

export default {
  components: {MHeader, MTab},
  data () {
    return {
      tabItems: [
        {name: '本次问诊', id: 'report'},
        {name: '上次体检', id: 'result'},
        {name: '疾病风险', id: 'risk'}
      ],
      symptomList: [
        {name: '所患疾病', select: ['糖尿病', '高血压', '慢阻肺']},
        {name: '不适症状', select: ['头疼', '心闷']},
        {name: '危险因素', select: ['糖尿病家族史', '喝酒']}
      ],
      symptomList1: [
        {name: '异常指标', select: ['甘油三酯偏高', '空腹血糖']},
        {name: '诊断结论', select: ['您可能患有糖尿病、心血管、高血压等疾病']}
      ]
    }
  },
  created () {
    window.scrollTo(0, 0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
.m-page {
  font-size: 14px;
  background: url("../../../public/images/personal/wzbg-000.png") no-repeat;
  background-size: 100%;
}

.m-content {
  position: relative;
  top: 44px;
  margin: 0 15px 20px 15px;
  padding: 10px 15px;
  border-radius: 8px;
  background-color: #ffffff;
  .m-portrait {
    position: absolute;
    left: 50%;
    top: -20px;
    transform: translateX(-50%);
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 50%;
  }
  .m-info {
    display: flex;
    justify-content: flex-end;
    .m-btn {
      height: 30px;
      line-height: 28px;
      padding: 0 10px;
      border: 1px solid #f25930;
      border-radius: 15px;
      background-color: #ffffff;
      color: #f25930;
    }
  }
  .m-title {
    text-align: center;
    > h2 {
      line-height: 40px;
      font-size: 16px;
      font-weight: bold;
      color: #666666;
    }
    > P {
      line-height: 20px;
      font-size: 12px;
      color: #999999;
    }
  }
  .m-tab {
    width: 80%;
    margin: 0 auto;
    padding: 20px 0;
  }
  .m-list {
    .m-item {
      border-bottom: 1px solid #f5f5f5;
      &:last-child {
        border: none;
      }
      .m-name {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 50px;
        line-height: 50px;
        margin-top: 10px;
        img {
          vertical-align: middle;
        }
        span {
          padding-left: 10px;
          color: #666666;
        }
        > i {
          color: #999999;
        }
      }
      .m-nape {
        padding-top: 5px;
        padding-bottom: 15px;
        > span {
          display: inline-block;
          padding: 8px 15px;
          margin-right: 10px;
          margin-bottom: 10px;
          line-height: 24px;
          font-size: 16px;
          border-radius: 8px;
          background-color: #fafafa;
          color: #333333;
        }
        .m-icon-1 {
          margin-right: 10px;
          color: #ffa81d;
        }
        .m-icon-2 {
          margin-left: 10px;
          font-size: 20px;
          color: #66b74e;
        }
      }
    }
    .m-item-end {
      width: 100%;
      height: 44px;
      line-height: 44px;
      text-align: center;
      margin-bottom: 20px;
      font-size: 12px;
      color: #999999;
      .icon {
        color: #ffa81d;
        margin: 0 5px;
      }
    }
  }
  .m-disease-box {
    margin-top: 20px;
    margin-bottom: 30px;
    text-align: center;
    .m-disease {
      position: relative;
      display: inline-block;
      width: 150px;
      height: 90px;
      margin-right: 10px;
      border-radius: 11px;
      background-color: #fafafa;
      &:nth-child(even) {
        margin: 0;
      }
      .m-tag {
        position: absolute;
        left: 0;
        top: 0;
        height: 22px;
        line-height: 22px;
        padding: 0 10px;
        font-size: 12px;
        border-radius: 11px 11px 11px 0;
        background-color: #ff594c;
        color: #ffffff;
      }
      .m-layout {
        display: flex;
        width: 100%;
        height: 40px;
        padding-top: 5px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        .m-left {
          width: 60px;
          > img {
            width: 40px;
          }
        }
        .m-right {
          flex: 1;
          text-align: left;
          > h4 {
            font-size: 16px;
            margin-bottom: 3px;
          }
          > p {
            font-size: 12px;
            color: #999999;
          }
        }
      }
    }

  }
}

.m-hint {
  width: 100%;
  border-radius: 17px;
  background-color: #fff9f1;
  color: #fda42e;
  > span {
    flex: 1;
    display: inline-block;
    line-height: 20px;
    padding: 7px 0 7px 12px;
    font-size: 12px;
  }
}

.m-hint-btn {
  display: flex;
  justify-content: space-between;
  > button {
    width: 80px;
    height: 24px;
    line-height: 22px;
    padding: 0 10px;
    margin: 5px;
    text-align: center;
    border-radius: 12px;
    border: 1px solid #f25930;
    background-color: #ffffff;
    color: #f25930;
  }
}

.m-foot {
  display: flex;
  flex: 1;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #ffffff;
  border-top: 1px solid #f5f5f5;
  .m-info {
    display: flex;
    flex: 1;
    padding-left: 15px;
    color: #666666;
    .m-info-left {
      flex: 1;
      font-size: 14px;
    }
    .m-info-right {
      width: 80px;
      text-align: center;
      > i {
        padding: 0 10px;
      }
    }

  }
  .m-reset {
    flex: 1;
    text-align: center;
    background-color: rgb(204, 204, 204);
    color: #ffffff;
  }
  .m-next {
    width: 50%;
    text-align: center;
    background-color: #f25930;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>
